// Feature Flag Constants - Single source of truth for all feature flag keys
export const FEATURE_FLAG_KEYS = {
    IDS_V2_ADAPTER: 'IDS_V2_ADAPTER',
    GLOBAL_CUSTOM_CODE: 'GLOBAL_CUSTOM_CODE',
    PROJECT_PLUGINS: 'PROJECT_PLUGINS',
    PROJECT_SELECTION: 'PROJECT_SELECTION',
    PAGE_SELECTION: 'PAGE_SELECTION',
    PULL_TASK: 'PULL_TASK',
    ADMIN_FILTERS: 'ADMIN_FILTERS',
    INBOX_PROJECTION: 'INBOX_PROJECTION',
    CHANGE_TRACKING: 'CHANGE_TRACKING',
    BPM_CONFIG_VERSION: 'BPM_CONFIG_VERSION',
    FALLBACK_TO_MAIN_CASEDEF: 'FALLBACK_TO_MAIN_CASEDEF',
} as const;

export type FeatureFlagKey = (typeof FEATURE_FLAG_KEYS)[keyof typeof FEATURE_FLAG_KEYS];

export function getFeatureFlagKey(key: keyof typeof FEATURE_FLAG_KEYS): string {
    return FEATURE_FLAG_KEYS[key];
}
